import moment from 'moment-timezone';
import 'moment/dist/locale/pl';
import 'moment/dist/locale/zh-cn';

export function initializeMoment(i18n, initialLanguage: string) {
  moment.locale(initialLanguage);

  const onLanguageChange = lng => {
    moment.locale(
      {
        zh: 'zh-cn'
      }[lng] ?? lng
    );
  };
  i18n.on('languageChanged', onLanguageChange);
  return () => {
    i18n.off('languageChanged', onLanguageChange);
  };
}
